<template>
	<div class="user_wrap">
		<div class="top_header">
			<!-- <div class="red_top_bg">
				<div class="big_tit">{{$t('home.my')}}</div>
				<div class="sign" @click="$router.push('/sign')">
					<img src="../images/user/sign.png">
				</div>
			</div> -->
			<div class="user_detail">
				<div class="user_header" @click="setavatar">
					<img :src="data.user_icon" alt="">
				</div>
				<div class="user_name">
					<div class="user_all">
						<p class="user_nickname">{{data.name?data.name:data.mobile}}</p>
						<!-- <p>ID:{{ data.uid }}</p> -->
						<!-- <div class="user_vip">
							<div class="vip-box">
								<div class="vip-badge"></div>
							</div>-->
							<!-- <p>{{$t('user.welcome')}}</p> -->
						<!--</div> -->
					</div>
				</div>
				<div class="msg" @click="$router.push('/language')" style="height: 40px;">
					<img :src="require('../images/language/'+lang+'.png')" style="height: 100%;">
				</div>
			</div>
		</div>
		<div class="user_block">
			<div class="user_grid clear">
				<div class="items-main">
					<div class="items_panel items_2" style="margin-bottom: 0;">
						<div class="items_header" style="margin-bottom: 0;">
							<span class="tt-lg">{{$t('user.availableBalance')}}</span>
						</div> 
						<div class="work_box">
							<div class="total_money" style="margin-bottom: 0px;">{{ data.money }}</div>
							<div class="item_btn_2">
								<button @click="$router.push('invest')" type="button">{{$t('user.recharge')}}</button>
								<button @click="$router.push('cash')" type="button">{{$t('user.withdraw')}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{$t('user.uncollectedPrincipal')}}</p>
						<p>{{data.wait_money}}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{$t('user.uncollectedInterest')}}</p>
						<p>{{data.wait_lixi}}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{$t('user.cumulativeIncome')}}</p>
						<p>{{data.all_lixi}}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_balance">
						<div>
							{{$t('user.totalBalance')}}
						</div>
						<div>
							{{data.all_money}}
						</div>
					</div>
				</div>
			</div>
			
			
			<!-- <div @click="$router.push('/kefu')" class="user_kf">
				<img src="../images/user/kf.png" alt="" />
				<p>{{$t('user.onlineService')}}</p>
			</div> -->
		</div>
		<div class="work_box">
			<div class="item" @click="$router.push('/sign')">
				<div class="item_img"><img src="../images/new/index-1.png" alt=""></div>
				<p class="item_title">{{$t('index.sign')}}</p>
			</div>
			<div class="item" @click="$router.push('/lixibao')">
				<div class="item_img"><img src="../images/new/index-3.png" alt=""></div>
				<p class="item_title">{{$t('index.lixibao')}}</p>
			</div>
			<div class="item" @click="$router.push('/myTeam')">
				<div class="item_img"><img src="../images/new/index-2.png" alt=""></div>
				<p class="item_title">{{$t('index.myteam')}}</p>
			</div>
			<div class="item" @click="$router.push('/share')">
				<div class="item_img"><img src="../images/new/index-10.png" alt=""></div>
				<p class="item_title">{{$t('index.aboutUs')}}</p>
			</div>


			<div class="item" @click="$router.push('/rechargeRecord')">
				<div class="item_img"><img src="../images/new/index-6.png" alt=""></div>
				<p class="item_title">{{$t('user.rechargeRecord')}}</p>
			</div>
			<div class="item" @click="$router.push('/withdrawRecord')">
				<div class="item_img"><img src="../images/new/index-7.png" alt=""></div>
				<p class="item_title">{{$t('user.withdrawalRecord')}}</p>
			</div>
			<div class="item" @click="$router.push('/order')">
				<div class="item_img"><img src="../images/new/index-9.png" alt=""></div>
				<p class="item_title">{{$t('user.myInvestment')}}</p>
			</div>
			<div class="item" @click="$router.push('/moneybag')">
				<div class="item_img"><img src="../images/new/index-4.png" alt=""></div>
				<p class="item_title">{{$t('user.transactionDetails1')}}<br />{{$t('user.transactionDetails2')}}</p>
			</div>


			<div class="item" @click="$router.push('/about/8')">
				<div class="item_img"><img src="../images/new/index-5.png" alt=""></div>
				<p class="item_title">{{$t('index.zhiwei')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/13')">
				<div class="item_img"><img src="../images/new/index-8.png" alt=""></div>
				<p class="item_title">{{$t('index.secret')}}</p>
			</div>
			<div class="item" @click="$router.push('/about/12')">
				<div class="item_img"><img src="../images/new/index-12.png" alt=""></div>
				<p class="item_title">{{$t('index.agreement1')}}<br />{{$t('index.agreement2')}}</p>
			</div>
			<div class="item" @click="$router.push('/safe')">
				<div class="item_img"><img src="../images/new/index-11.png" alt=""></div>
				<p class="item_title">{{$t('user.setting1')}}<br />{{$t('user.setting2')}}</p>
			</div>
		</div>
		<!-- <div class="user_yw">
			<div @click="$router.push('/order')">
				<img src="../images/user/order.png" alt="" />
				<p>{{$t('user.myInvestment')}}</p>
			</div>
			<div @click="$router.push('/moneybag')">
				<img src="../images/user/details.png" alt="" />
				<p>{{$t('user.transactionDetails')}}</p>
			</div>
			<div @click="$router.push('/kefu')">
				<img src="../images/user/kf.png" alt="" />
				<p>{{$t('user.onlineService')}}</p>
			</div>
		</div> -->
		
		<div class="list">
			<!-- <van-cell is-link @click="$router.push('/moneybag')">
				<template #title>
					<img src="../images/user/moneybag.png" alt="" />
					<span class="custom-title">{{$t('user.myWallet')}}</span>
				</template>
			</van-cell> -->
			<!-- <van-cell is-link @click="$router.push('/about/13')">
				<template #title>
					<img src="../images/user/cz.png" alt="" />
					<span class="custom-title">{{$t('index.secret')}}</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/about/12')">
				<template #title>
					<img src="../images/user/tx.png" alt="" />
					<span class="custom-title">{{$t('index.agreement')}}</span>
				</template>
			</van-cell> -->
			<!-- <van-cell is-link @click="$router.push('/myTeam')">
				<template #title>
					<img src="../images/user/team.png" alt="" />
					<span class="custom-title">{{$t('index.invite')}}</span>
				</template>
			</van-cell> -->
			<!-- <van-cell is-link @click="$router.push('/safe')">
				<template #title>
					<img src="../images/user/setting.png" alt="" />
					<span class="custom-title">{{$t('user.setting')}}</span>
				</template>
			</van-cell> -->
		</div>

		<van-dialog v-model="show_tz" theme="round-button" @confirm="submit" :confirmButtonText="$t('utils.submit')"  style="top:50%;background-color: #200a6e;">
			<div class="close-x" @click="show_tz = false"><van-icon name="cross" /></div>
			<div class="show-body">
				<div class="qrcode sw-cell">
					<div class="sw-label">{{$t('user.avatar')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="10 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead1"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
    import axios from 'axios'
	import {
		Icon,
		Uploader,
		Cell,
		CellGroup,Toast
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon).use(Uploader);

	export default {
		name: "user",
		components: {},
		data() {
			return {
				lang:this.$i18n.locale||"ja_jp",
				data: {},
				eye: 1,
				checked:true,
				show_tz: false,
				fileList: [],
				avatar: ''
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
		},
		methods: {
			onOversize(file) {
			    this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
			    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
			        this.$toast(this.$t('account.supportPicture'));
			        return false;
			    }
			    return true;
			},
			afterRead1(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.avatar = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			setavatar(){
				
				this.show_tz = true;
			},
			submit(){
				Fetch('/user/avatar',{
					avatar: this.avatar
				}).then((r) => {
					if (r.data.code === 1) {
						this.$toast(r.data.info);
			        } else {
			            this.$toast(this.$t('account.uploadFail'));
			        }
					this.start();
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		position: relative;
		background: unset;

		.sign {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 20px;

			img {
				height: 100%;
			}
		}
	}


	.user_block {
		padding: 10px 15px;

		.user_kf {
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 5px;
			background-image: linear-gradient(to right, #ff5252, #ff8244);
			box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
			color: #fff;
			font-size: 12px;
			padding: 10px;

			img {
				width: 27px;
				height: 27px;
				margin-right: 8px;
			}
		}

		.user_grid {
			margin: 0px;
			background-color: #1d0554;

			.user_grid__item {
				float: left;
				width: 50%;
				padding: 0 7.5px;
				box-sizing: border-box;

				.user_grid__card {
					//border: 1px solid #eeeeee;
					background-color: #2a1164;
					border-radius: 5px;
					//box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
					margin-bottom: 10px;
					text-align: center;
					padding: 12px;
				}

				.user_money {
					p:nth-child(1) {
						font-size: 14px;
						color: #ffffff;
					}

					p:nth-child(2) {
						font-size: 16px;
						color: #ef5040;
						margin-top: 8px;
					}
				}

				.user_balance {
					div:nth-child(1) {
						font-size: 14px;
						color: #ffffff;
					}

					div:nth-child(2) {
						font-size: 18px;
						color: #ef5040;
						margin-top: 8px;
					}
				}
			}
		}
	}


	.user_wrap {
		max-width: 100%;
		overflow: hidden;
		padding-bottom: 20px;
		background-color: #250767;
	}

	.top_header {
		position: relative;
		width: 100%;
		height: 90px;
		//background-image: url(../images/user/user_bg.jpg);
		//background-position: center;
		//background-repeat: no-repeat;
		//background-size: 100% 100%;

		.user_detail {
			//width: 100%;
			padding: 28px 15px 0;
			.user_header {
				width: 48px;
				height: 48px;
				overflow: hidden;
				//margin: 0 auto;
				border-radius: 50%;
				float: left;

				img {
					width: 100%;
					height: 100%;
					border: 2px solid #FFFFFF;
					border-radius: 30px;
				}
			}

			.user_name {
				margin-top: 5px;
				color: #FFFFFF;
				//text-align: center;
				float: left;
				padding-left: 15px;

				.user_all {

					.user_nickname {
						line-height: 22px;
						font-size: 15px;
						font-weight: bold;
					}
					
					.user_vip {
						color: #FFFFFF;
						text-align: center;
						//padding: 8px 15px;

						.vip-box {
							position: relative;
							text-align: center;
							font-size: 12px;
							min-width: 45px;
							padding: 0 14px;
							line-height: 15px;
							border-radius: 8px;
							display: inline-block;
							background-image: linear-gradient(to right, #ffa51e, #ffe462);

							.vip-badge {
								position: absolute;
								left: -8px;
								top: -2.5px;
								width: 20px;
								height: 20px;
								background-image: url(../images/user/badge.png);
								background-position: center;
								background-repeat: no-repeat;
								background-size: 100% 100%;
							}
						}
					}
				}
			}
			.msg{float: right;}
		}


		.user_balance {
			text-align: center;

			div {
				margin: 10px 0;
			}

			div:nth-child(1) {
				font-size: 14px;
				color: #d3d5d6;
			}

			div:nth-child(2) {
				font-weight: bold;
				font-size: 16px;
				color: #FFFFFF;
			}
		}

		.user_money {
			display: flex;
			justify-content: space-between;
			text-align: center;

			p {
				margin: 10px 0;
			}

			div {
				width: 33.33%;
			}

			p:nth-child(1) {
				font-size: 14px;
				color: #d3d5d6;
			}

			p:nth-child(2) {
				font-size: 14px;
				color: #FFFFFF;
			}
		}
	}

	.kong {
		width: 100%;
		height: 35px;
		background: #FFFFFF;
	}

	.user_yw {
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		position: relative;
		// top: -83px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 15px 0;

		div {
			width: 33.33%;
		}

		p {
			margin-top: 8px;
		}

		img {
			width: 30px;
			height: 30px;
		}
	}

	.money {
		background: #FFFFFF;
		padding: 15px 15px 20px;
		border-bottom: 1px solid #eeeeee;
		border-top: 1px solid #eeeeee;

		.money-hd {
			text-align: center;

			p:nth-child(1) {
				color: #999;
				margin-bottom: 10px;
			}

			p:nth-child(2) {
				font-size: 14px;
				color: #ff5252;
				font-weight: bold;
			}
		}

		.money-bd {
			text-align: center;
			margin-top: 13px;

			span {
				padding: 3.5px 7px;
				border-radius: 5px;
				margin: 0 8px;
				width: 124px;
				line-height: 2;
				font-size: 14px;
				display: inline-block;
				color: #FFFFFF;
			}

			span:nth-child(1) {
				background: #ff5451;
			}

			span:nth-child(2) {
				background: #04c382;
			}
		}
	}

	.list {
		margin: 15px;
		
		.van-cell{
			padding: 8px 15px;
			background-color:#1b0350;
			.van-cell__title{
				display: flex;
				align-items: center;
				color: #ffffff;
				font-size: 12px;
				
				img {
					height: 17px;
					width: 17px;
					margin-right: 6px;
					vertical-align: middle;
				}
			}
		}
		
		.van-cell::after{
			left: 0;
			right: 0;
			border-bottom: 1px solid #4e21b1;
		}
	}
	
	.work_box {
		//background: #FFFFFF;
		padding: 17px 8px 4px 8px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		.item {
			width: 25%;
			text-align: center;
			margin-bottom: 10px;
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				img {
					width: 52px;
					height: 52px;
				}
			}

			.item_title {
				width: 100%;
				line-height: 14px;
				font-size: 12px;
				color: #ffffff;
				text-align: center;
			}
		}
	}
	
	.items-main{
		padding: 15px;
	}
	.items_panel{
		margin-bottom: 15px;
	}
	.total_money{
		font-size: 24px;
		color:#ffffff;
	}
	.items_header{
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		.tt-lg{
			font-size: 16px;
			color:#ffffff;
		}
		.tit_tip{
			font-size: 12px;
			color: #999;
			margin-left: auto;
		}
		.tt-link{
			font-size: 12px;
			color: #999999;
			margin-left: 20px;
		}
	}
	.item_btn_2{
		button{
			min-width: 75px;
			color: #ffffff;
			padding: 8px;
			border-radius: 5px;
			border: 1px solid #ff5451;
			margin-left: 10px;
			background-color: #ff5451;
		}
		button:first-child{
			background-color: #04c382;
			border: 1px solid #04c382;
		}
	}.show-body{
		padding: 20px;
		font-size: 14px;
		.sw-label{
			margin: 10px 0;
			color:#ffffff;
		}
		.sw-bar{
			display: flex;
			align-items: center;
			background-color: #180658;
			padding: 10px;
			border-radius: 4px;
			.flex_bd{
				color: #999999;
				.van-cell{
					padding: 2px 10px;
				}
			}
		}
	}
	.sw-grid{
		display: flex;
		align-items: flex-end;
		margin-top: 20px;
		.sw-row:first-child{
			margin-bottom:20px;
		}
		.sw-row > div:first-child{
			margin-bottom: 10px;
		}
		
		.sw-info{
			color: #999;
		}
		.sw-val.text-green{
			font-size: 16px;
		}
	}
	.sw-right{
		text-align: center;
		.sw-lg{
			font-size: 20px;
			margin-bottom: 10px;
		}
	}
	/deep/div.van-goods-action{
		background-color: #200a6e !important;
	}
	.close-x{
		color: #999;
		position: absolute;
		right: 12px;
		top: 12px;
	}
	.close-x .van-icon{
		font-size: 20px;
	}
	.qrcode{
		padding-top: 30px;
		padding-bottom: 30px;
		text-align: center;
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 20px;
		}
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 250px;
			height: 250px;
			margin: 0 auto;
			background: linear-gradient(to left, #999, #999) left top no-repeat, 
						linear-gradient(to bottom, #999, #999) left top no-repeat, 
						linear-gradient(to left, #999, #999) right top no-repeat,
						linear-gradient(to bottom, #999, #999) right top no-repeat, 
						linear-gradient(to left, #999, #999) left bottom no-repeat,
						linear-gradient(to bottom, #999, #999) left bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat,
						linear-gradient(to left, #999, #999) right bottom no-repeat;
			background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
			span{
				line-height: 220px;
			}
			img{
				width: 240px;
				height: 240px;
				position: relative;
				top: -255px;
			}
		}
	}
	/deep/ .van-uploader__input-wrapper {
	    width: 100%;
	}
	/deep/ .van-uploader__wrapper{
		width: 100%;
		height: 100%;
	}
	/deep/ .van-uploader__upload{
		width: 100%;
		height: 100%;
		margin:0;
	}
	/deep/ .van-uploader__preview{
		margin:0;
	}
	/deep/ .van-uploader__preview-image{
		width: 100%;
		height: 100%;
	}
</style>
